export default __webpack_public_path__ + "how-to.f4acf2.jpg";